import { useId } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function NewChatIcon({
  size = 24
}) {
  const id = useId();
  const clip0 = `${id}-clip0`;
  const clip1 = `${id}-clip1`;
  const clip2 = `${id}-clip2`;
  const mask0 = `${id}-mask0`;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: `url(#${clip0})`,
      children: [/*#__PURE__*/_jsx("mask", {
        id: mask0,
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        children: /*#__PURE__*/_jsx("g", {
          clipPath: `url(#${clip1})`,
          children: /*#__PURE__*/_jsxs("g", {
            clipPath: `url(#${clip2})`,
            children: [/*#__PURE__*/_jsx("path", {
              d: "M15.5356 6.96428C16.2428 6.96428 16.8214 7.54285 16.8214 8.24999V10.3929C16.8214 10.6286 16.6285 10.8214 16.3928 10.8214C16.1571 10.8214 15.9642 10.6286 15.9642 10.3929V8.24999C15.9642 8.01428 15.7714 7.82142 15.5356 7.82142H7.82136C7.58564 7.82142 7.39279 8.01428 7.39279 8.24999V15.9643C7.39279 16.2 7.58564 16.3929 7.82136 16.3929H9.53564C9.77136 16.3929 9.96422 16.5857 9.96422 16.8214C9.96422 17.0571 9.77136 17.25 9.53564 17.25H7.82136C7.11422 17.25 6.53564 16.6714 6.53564 15.9643V8.24999C6.53564 7.54285 7.11422 6.96428 7.82136 6.96428H15.5356Z",
              fill: "#141414"
            }), /*#__PURE__*/_jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.4814 10.3929C14.5971 10.3929 14.7042 10.44 14.7856 10.5172L17.5542 13.2857C17.7213 13.4529 17.7213 13.7229 17.5542 13.8901L14.3228 17.1215C14.2413 17.2029 14.1342 17.2458 14.0185 17.2458V17.25H11.2499C11.0142 17.25 10.8214 17.0571 10.8214 16.8214V14.0529C10.8214 13.9372 10.8685 13.83 10.9457 13.7486L14.1771 10.5172C14.2585 10.4357 14.3657 10.3929 14.4814 10.3929ZM11.6785 14.2286V16.3929H13.8427L15.3578 14.8778L13.1936 12.7136L11.6785 14.2286ZM13.7979 12.1092L15.9621 14.2734L16.6456 13.59L14.4814 11.4258L13.7979 12.1092Z",
              fill: "#141414"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: `url(#${mask0})`,
        children: /*#__PURE__*/_jsx("path", {
          d: "M6 6H18V18H6V6Z",
          fill: "currentColor"
        })
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("clipPath", {
        id: clip0,
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(6 6)"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: clip1,
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(6 6)"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: clip2,
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(6 6)"
        })
      })]
    })]
  });
}